import React from 'react';
import { PiHouseLineFill } from 'react-icons/pi';
import { NavSubmenuDivider, NavSubmenuLabel } from './navMenuLayout';
import AreaBudgetNavPanel from './AreaBudgetNavPanel';
import { canAccessAreaBudgetMenu } from './areaBudgetNavUtils';

const BASECAMP_CHILD_ROUTES = [
  '/budgets/basecamp',
  '/budgets/new',
  '/budgets/management?area=basecamp',
  '/dailies/basecamp/new',
  '/dailies/management?area=basecamp',
  '/summary/basecamp',
  '/basecamp/camp-layout',
];

export default function BaseCampNavSection({
  MenuItem,
  SubMenuItem,
  hasMenuAccess,
  hasMenuAccessOrChild,
  closeMobileSidebar,
}) {
  if (!hasMenuAccessOrChild('/basecamp', BASECAMP_CHILD_ROUTES)) {
    return null;
  }

  const canAccessBudget = canAccessAreaBudgetMenu('basecamp', hasMenuAccess);

  return (
    <MenuItem customIcon={<PiHouseLineFill style={{ width: '24px', height: '24px' }} />} title="Base Camp" id="basecamp">
      {(canAccessBudget
        || hasMenuAccess('/dailies/basecamp/new')
        || hasMenuAccess('/dailies/management?area=basecamp')) && (
        <>
          <NavSubmenuLabel>Planning</NavSubmenuLabel>
          {canAccessBudget && (
            <AreaBudgetNavPanel
              area="basecamp"
              SubMenuItem={SubMenuItem}
              hasMenuAccess={hasMenuAccess}
              closeMobileSidebar={closeMobileSidebar}
            />
          )}
          {hasMenuAccess('/dailies/basecamp/new') && <SubMenuItem to="/dailies/basecamp/new">New Daily</SubMenuItem>}
          {hasMenuAccess('/dailies/management?area=basecamp') && (
            <SubMenuItem to="/dailies/management?area=basecamp">Dailies Management</SubMenuItem>
          )}
        </>
      )}
      {hasMenuAccess('/basecamp/camp-layout') && (
        <>
          <NavSubmenuDivider />
          <NavSubmenuLabel>Operations</NavSubmenuLabel>
          <SubMenuItem to="/basecamp/camp-layout">🏕️ Camp Layout</SubMenuItem>
        </>
      )}
      {hasMenuAccess('/summary/basecamp') && (
        <>
          <NavSubmenuDivider />
          <NavSubmenuLabel>Reports</NavSubmenuLabel>
          <SubMenuItem to="/summary/basecamp">Summary</SubMenuItem>
        </>
      )}
    </MenuItem>
  );
}
